import api from "./api";

const ServicePlanAPI = {
    getAll: () => api.get("/service-plan/all"),
    getByServiceType: (serviceTypeId) => api.get(`/service-plan/service-type/${serviceTypeId}`),
    getById: (servicePlanId) => api.get(`/service-plan/details/${servicePlanId}`),
    update: (params) => api.post(`/service-plan/update`, params),
    getPlanFeatureByUser: () => api.get(`/service-plan/feature`),
    getPlanDescription: () => api.get(`/service-plan/description`),
    updPlanDescription: (params) => api.post(`/service-plan/description`, params),
    checkExistFreePlan: () => api.get(`/service-plan/check-exist-free-plan`),
    confirmFreePlan: () => api.get(`/service-plan/confirm-free-plan`),
};

export default ServicePlanAPI;